import React from 'react';
import styled from 'styled-components';

import { FilestackImageData } from 'api/types/shared.types';
import { Image } from 'components/Image';
import { breakpoints } from 'theme';
import { getImageSrc } from 'utils/getImageSrc';

const BannerImage = styled(Image)<{ $mobileImageHandle?: boolean }>`
  ${({ $mobileImageHandle }) =>
    $mobileImageHandle
      ? `
        display: none;
        @media (min-width: ${breakpoints[3]}) {
          display: block;
        }
      `
      : `
        display: block;
      `}
`;

type Props = {
  image: FilestackImageData;
  mobileImage?: FilestackImageData;
  alwaysShow?: boolean;
  convert?: boolean;
};

export function Banner({ image, mobileImage, alwaysShow, convert }: Props) {
  const isSvg = image && image.mimetype.includes('image/svg');

  const imageSrc = getImageSrc({
    handle: image.handle,
    width: 1920,
    height: 1024,
    format: convert ? 'jpg' : undefined,
    mimetype: image.mimetype,
  });

  const imageSrc2 = getImageSrc({
    handle: image.handle,
    width: 2400,
    height: 1152,
    format: convert ? 'jpg' : undefined,
    mimetype: image.mimetype,
  });

  return (
    <BannerImage
      data-qa-id="hero-image-image"
      $mobileImageHandle={!!(mobileImage && mobileImage.handle)}
      width={1920}
      height={1024}
      alt={getText('Hero image')}
      src={imageSrc}
      srcSet={`${imageSrc}, ${imageSrc2} 2x`}
      alwaysShow={alwaysShow}
      svg={isSvg}
    />
  );
}
